import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SelectionId } from 'src_common/common/websocket2/id/WebsocketId';
import {
    TrapWrapperNextRaces,
    WidgetTrapBox,
} from 'src/domains/sportsbook/webview/components/nextRaces/raceBoxSelection/WidgetTrap.style';

interface WidgetTrapPropsType {
    selectionId: SelectionId;
}

export const WidgetTrap = observer('WidgetTrap', (props: WidgetTrapPropsType) => {
    const { selectionId } = props;
    const selection = selectionId.getModel();
    const market = selection?.marketId2.getModel() ?? null;

    if (selection === null || market === null) {
        return null;
    }

    if (market.isOutright) {
        return null;
    }

    return (
        <WidgetTrapBox>
            <TrapWrapperNextRaces
                trapNumber={selection.metaDataNumber}
                selectionId={selection.id2}
            />
        </WidgetTrapBox>
    );
});
